import CategoryPage from '~/src/pages/categoryPage/CategoryPage';
export default CategoryPage;
